
import { css } from 'lit';
export default css`
.menu-link{
  --menu-link-border-color:var(--purple-indigo);

  transition:background-size 0.3s;
  background-image:linear-gradient(
    transparent calc(100% - 2px),
    var(--menu-link-border-color) 2px
  );
  background-size:0 100%;
  background-repeat:no-repeat;
}

.menu-link:hover,
.menu-link:focus{
  background-size:100% 100%;
  color:var(--purple-indigo);
}

.menu-link.menu-link--default{
  --menu-link-border-color:transparent;

  border-bottom:1px solid var(--purple-medium-neutral);
  background-color:var(--primary-white);
  padding:var(--spacing-5) var(--spacing-8);
  width:100%;
  font-weight:500;
  font-size:var(--fs-body-mobile);
  font-family:var(--ff-body);
}

.menu-link.menu-link--title{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-3);
  font-size:var(--fs-h5);
  line-height:var(--lh-h5);
}

.menu-link.menu-link--title:hover,
.menu-link.menu-link--title:focus{
  background-size:calc(100% - 28px) 100%;
}

.menu-link.menu-link--title pc-icon{
  color:var(--purple-indigo);
}

@media (min-width: 992px){
  .menu-link.menu-link--default{
    --menu-link-border-color:var(--purple-indigo);

    margin:var(--spacing-4) 0;
    border-bottom:none;
    background-color:transparent;
    padding:0 0 4px 0;
    width:-moz-fit-content;
    width:fit-content;
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  .menu-link.menu-link--level-1{
    --menu-link-border-color:var(--purple-indigo-light);

    margin:0;
    color:var(--primary-white);
  }

  .menu-link.menu-link--level-1:hover{
    color:var(--primary-white);
  }

  .menu-link.menu-link--title{
    font-size:var(--fs-h3);
    line-height:var(--lh-h3);
  }
}
`;